.subscription-required {
	color: #000;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;

	height: 100%;
}

.subscription-required section {
	border: 1px solid #c0c0c0;
	border-radius: 4px;
	padding: 50px;
	background: #fff;
}

.subscription-required section button {
	padding: 10px 15px;
}

.subscription-required h1 {
	font-size: 1.8rem;
	line-height: 1.2;
	margin-bottom: 10px;
}

.subscription-required h2 {
	color: #000;
	font-size: 1rem;
	line-height: 1.2;
}

.subscription-required button {
	border-radius: 4px;
	padding: 10px 15px;
	border: 1px solid;
	font-weight: bold;
	border-color: var(--app-accent-color);
	background: #fff;
	color: var(--app-accent-color);
	margin: 20px 0px;
	cursor: pointer;
	transition:
		background ease-out 220ms,
		color ease-out 220ms;
}

.subscription-required button {
	background: var(--app-accent-color);
	color: #fff;
}

.subscription button:hover {
	background: var(--app-accent-color);
	color: #fff;
}

.article {
	position: relative;
	width: 100%;
	max-width: 100%;
	overflow-x: hidden;
	box-sizing: border-box;
}
.article p {
	overflow-wrap: break-word;
}

.article li {
	text-align: start;
}

.article ul {
	display: block;
	list-style-type: disc;
	margin-block-start: 1em;
	margin-block-end: 1em;
	margin-inline-start: 0px;
	margin-inline-end: 0px;
	padding-inline-start: 40px;
}

.article ul,
.article li {
	width: 100%;
	list-style: disc;
	list-style-position: inside;
}

.article button:disabled {
	opacity: 0.5;
	cursor: not-allowed !important;
}

.article figure {
	margin: 0;
	margin-block-start: 0em;
	margin-block-end: 0em;
	margin-inline-start: 0px;
	margin-inline-end: 0px;
}

article[dir="rtl"].article .body.dropcap > :first-child::first-letter {
  float: none;
  font-size: inherit;
  font-family: inherit;
  color: inherit;
  margin-top: 0;
  margin-bottom: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding: 0;
}

.canvas {
	display: block;
	height: 100%;
	max-width: 1024px;
	box-sizing: border-box;
	margin-inline-start: auto;
	margin-inline-end: auto;
}

.article p {
	font-weight: 400;
}

.canvas li {
	text-align: start;
}

.canvas cite {
	width: auto;
}

.canvas.ad {
	overflow: hidden;
	height: 100%;
	max-height: 100%;
}

.canvas.ad > div {
	height: 100%;
}

.image {
	color: #000;
	display: flex;
	align-items: center;
	flex-direction: column;
	-webkit-transform-style: preserve-3d;
	transform-style: preserve-3d;
	-webkit-perspective: 1000;
	perspective: 1000;
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
	/*display: flex;
	flex-direction: column;
	-webkit-transform-style: preserve-3d;
	-webkit-perspective: 1000;
	-webkit-backface-visibility: hidden;*/
}

.image > img,
.image > a > img {
	max-width: 100%;
	/*object-fit: cover;*/
	-webkit-transform-style: preserve-3d;
	transform-style: preserve-3d;
	-webkit-perspective: 1000;
	perspective: 1000;
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
	/* A native reader either does nothing on long-press or opens its own
	   menu; here it opened Safari's save/copy callout. Pairs with the
	   `user-select: none` already applied at the app-shell level. */
	-webkit-touch-callout: none;
}

.image > figcaption {
	text-align: center;
	padding-inline-start: 10px;
	max-width: 100%;
	width: 100%;
	box-sizing: border-box;
}

.image > cite {
	display: block;
	text-align: center;
}

.infogram {
	display: block;
}

.map {
	width: 100%;
	height: 45vh;
	overflow: hidden;
}

.map > :first-child {
	height: 100%;
	width: 100%;
}

.gallery {
	height: auto;
	margin-bottom: 25px;
}

.gallery > figcaption {
	margin-top: 5px;
	text-align: center;
}

.gallery-slider {
	margin: auto 0px;
}

.gallery-slider.hide > .gallery-image {
	opacity: 0;
}

.gallery-image {
	width: 100%;
	max-width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	margin-bottom: 20px;
}

.gallery-image img {
	object-fit: cover;
	width: 100%;
	max-width: 100% !important;
	/* Same as `.image > img`: no Safari save/copy sheet on long-press. */
	-webkit-touch-callout: none;
}

.gallery-image figcaption {
	margin-bottom: 20px;
}

.video:not(.auto) figure {
	position: relative;
	padding-bottom: 56.25%;
	height: 0;
}
.video iframe,
.video object,
.video embed,
.video video {
	top: 0;
	inset-inline-start: 0;
	background: #fafafa;
}

.video video {
	max-width: 100%;
	margin: 0 auto;
	display: block;
}

.video.auto {
	padding-bottom: unset;
	height: unset;
	overflow: unset;
}

.video.auto iframe,
.video.auto object,
.video.auto embed,
.video.auto video {
	position: unset;
	top: unset;
	inset-inline-start: unset;
	width: unset;
	height: unset;
}

.anchor {
	width: 0;
	height: 0;
	opacity: 0;
}

.video {
	display: block;
	position: relative;
}

.video > figcaption {
	text-align: start;
	padding: 2% 20px;
	color: #000;
}

.video > cite {
	text-align: start;
	padding: 0px 20px;
	color: #000;
}

.tweet > div > div {
	display: flex;
	justify-content: center;
}

.twitter {
	overflow: auto;
}

.twitter > div {
	width: 100%;
	height: 100%;
}

.twitter > div > div {
	width: 100%;
	height: 100%;
}

.columns {
	display: grid;
	grid-template-rows: 1fr;
	grid-column-gap: 15px;
	margin: 0px;
	overflow: hidden;
	max-width: 100%;
	padding: 0px;
	background-size: cover !important;
}

.columns > div {
	width: unset;
	overflow: hidden;
}

.columns .gallery-slider {
	width: 100% !important;
}

.columns > div > figure.float-left {
	float: inline-start;
	margin-bottom: 0px !important;
}

.columns > div > figure.float-right {
	float: inline-end;
	margin-bottom: 0px !important;
}

.columns > div > * {
	max-width: 100% !important;
}

.column-1 {
	display: grid;
	grid-template-rows: 1fr;
	gap: 0px 0px;
	grid-template-areas: '.';
}

.column-2 {
	grid-template-areas: '. .';
}

.column-3 {
	grid-template-areas: '. . .';
}

.column-4 {
	grid-template-areas: '. . . .';
}

.collapse {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: stretch;
}

.advert {
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	height: 100%;
}

.advert img {
	object-fit: contain;
	min-height: 100%;
	height: 100%;
	overflow: hidden;
}

.tabs {
	padding: 0px;
}

.tabs > div {
	display: flex;
	flex-direction: column;
}

.tabs .tab {
	height: 100%;
	min-width: 100px;
	background: white;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	z-index: 100;
	border: 1px solid transparent;
}

.tab.selected {
	cursor: unset;
	border-color: #eaeaea;
}

.tabs nav {
	min-height: unset;
	display: flex;
}

.tabs nav > div {
	padding: 5px 25px;
}

.tabs .content {
	min-height: 100px;
}

/*.multicol .component p,
.multicol figure {
	page-break-inside: avoid;
	break-inside: avoid-column;
	display: inline-table;
	overflow: hidden;
}*/

.multicol figure {
	display: contents;
}

.tiktok {
	position: relative;
}

.instagram {
	position: relative;
	display: flex;
	justify-content: center;
}

.articles-container {
	width: 100%;
	height: 100%;
	max-height: 100%;
	overflow: hidden;
}

.articles-container > :first-child {
	height: 100%;
	max-height: 100%;
}

.article-swiper > div {
	overflow: auto;
	overscroll-behavior-y: contain;
	width: 100%;
	height: 100%;
}

.article-swiper article {
	overflow-y: auto;
	overscroll-behavior-y: contain;
}

/*VIRTUAL*/

.articles-virtual {
	color: #000;
	height: 100%;
	overflow: hidden;
}

/* The reader's article scroller. Vertical only: no rubber-band past the
   end, no scroll chaining, no accidental pull-to-refresh -- while the x
   axis keeps the browser's swipe-back gesture. */
.articles-virtual article {
	height: 100%;
	overflow-y: auto;
	overscroll-behavior-y: contain;
}

.mosaic-container {
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	grid-gap: 0.5rem;
	max-width: 1024px;
	margin: 0 auto;
}

.gallery .mosaic-container[items-count='2'] .tile,
.gallery .mosaic-container[items-count='4'] .tile,
.gallery .mosaic-container[items-count='6'] .tile,
.gallery .mosaic-container[items-count='8'] .tile,
.gallery .mosaic-container[items-count='10'] .tile,
.gallery .mosaic-container[items-count='12'] .tile,
.gallery .mosaic-container[items-count='14'] .tile,
.gallery .mosaic-container[items-count='16'] .tile,
.gallery .mosaic-container[items-count='18'] .tile,
.gallery .mosaic-container[items-count='20'] .tile {
	grid-column: span 3;
	grid-row: auto;
}

.mosaic-container .tile img {
	-webkit-touch-callout: none;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.mosaic-container .tile,
.mosaic-container .tile:nth-child(7) {
	grid-column: span 6;
	grid-row: auto;
}
.mosaic-container .tile:nth-child(4),
.mosaic-container .tile:nth-child(5),
.mosaic-container .tile:nth-child(6),
.mosaic-container .tile:nth-child(9),
.mosaic-container .tile:nth-child(11),
.mosaic-container .tile:nth-child(13),
.mosaic-container .tile:nth-child(15),
.mosaic-container .tile:nth-child(17),
.mosaic-container .tile:nth-child(19) {
	grid-column: span 3;
	grid-row: auto;
}
.mosaic-container .tile {
	grid-column: span 3;
	grid-row: auto;
}
.mosaic-container .tile:nth-child(1),
.mosaic-container .tile:nth-child(1),
.mosaic-container .tile:nth-child(1),
.mosaic-container .tile:nth-child(1),
.mosaic-container .tile:nth-child(1),
.mosaic-container .tile:nth-child(1),
.mosaic-container .tile:nth-child(1),
.mosaic-container .tile:nth-child(1),
.mosaic-container .tile:nth-child(1) {
	grid-column: span 4;
	grid-row: span 2;
}
.mosaic-container .tile:nth-child(2),
.mosaic-container .tile:nth-child(3),
.mosaic-container .tile:nth-child(2),
.mosaic-container .tile:nth-child(3),
.mosaic-container .tile:nth-child(2),
.mosaic-container .tile:nth-child(3),
.mosaic-container .tile:nth-child(4),
.mosaic-container .tile:nth-child(5),
.mosaic-container .tile:nth-child(6),
.mosaic-container .tile:nth-child(2),
.mosaic-container .tile:nth-child(3),
.mosaic-container .tile:nth-child(2),
.mosaic-container .tile:nth-child(3),
.mosaic-container .tile:nth-child(2),
.mosaic-container .tile:nth-child(3),
.mosaic-container .tile:nth-child(2),
.mosaic-container .tile:nth-child(3),
.mosaic-container .tile:nth-child(2),
.mosaic-container .tile:nth-child(3),
.mosaic-container .tile:nth-child(2),
.mosaic-container .tile:nth-child(3) {
	grid-column: span 2;
}

.youtube-video iframe {
	aspect-ratio: 16 / 9;
	width: 100%;
}

@media screen and (max-width: 400px) {
	.mosaic-container .container {
		display: block;
	}
	.mosaic-container .tile {
		margin-bottom: unset!important;
	}
}

@media screen and (max-width: 767px) {
	.advert {
		min-height: 100%;
		max-height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}

@media screen and (min-width: 767px) {
	.advert {
		min-height: 100%;
		max-height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}

@media print {
	.canvas {
		display: block;
		overflow-y: visible;
	}
}
